"use client"
import { useEffect } from 'react'
import { gaEvent } from '../../src/lib/gtag'

export default function AnalyticsClient() {
  useEffect(() => {
    let canceled = false
    async function run() {
      try {
        const nav: any = navigator
        const uaData = nav.userAgentData
        let ch: any = {}
        if (uaData && typeof uaData.getHighEntropyValues === 'function') {
          try {
            ch = await uaData.getHighEntropyValues([
              'platform','platformVersion','model','architecture','bitness','uaFullVersion','fullVersionList','wow64'
            ])
          } catch {}
        }
        const screen_w = window.screen?.width || 0
        const screen_h = window.screen?.height || 0
        const viewport_w = window.innerWidth || 0
        const viewport_h = window.innerHeight || 0
        const language = navigator.language || ''
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''
        const mobile = !!(uaData?.mobile || /Mobi|Android/i.test(navigator.userAgent || ''))

        let geo_country: string | undefined
        const USE_GEO = String(process.env.NEXT_PUBLIC_USE_GEO) === '1'
        if (USE_GEO) {
          try {
            const resp = await fetch('/api/geo', { cache: 'no-store' })
            const data = await resp.json().catch(()=>({}))
            geo_country = data?.country
          } catch {}
        }

        if (canceled) return
        gaEvent('device_info', {
          device_platform: ch.platform || navigator.platform || '',
          platform_version: ch.platformVersion || '',
          device_model: ch.model || '',
          architecture: ch.architecture || '',
          bitness: ch.bitness || '',
          browser_full_version: ch.uaFullVersion || '',
          mobile,
          screen_w, screen_h, viewport_w, viewport_h,
          language, timezone,
          geo_country: geo_country || ''
        })
      } catch {}
    }
    // Defer to idle time to avoid impacting LCP/TTI
    const idle = (window as any).requestIdleCallback as undefined | ((cb: any, opts?: any) => any)
    const id = idle ? idle(run, { timeout: 2000 }) : setTimeout(run, 0)
    return () => { canceled = true }
  }, [])
  useEffect(() => {
    try {
      const path = window.location.pathname || ''
      const ref = (document.referrer || '').toLowerCase()
      const firstKey = 'first_touch_hint_sent'
      if (sessionStorage.getItem(firstKey) === '1') return

      const isBlog = path.startsWith('/blog')
      const isExplore = path.startsWith('/explore')
      const isProduct = path.startsWith('/category/') || path.startsWith('/product/') || path.startsWith('/p/')

      let source = 'direct'
      if (isExplore) {
        source = 'instagram'
      } else if (isProduct) {
        source = 'google_search'
      } else if (isBlog) {
        source = 'instagram_or_google'
      }

      const pageName = path === '/' ? '/home' : path.split('?')[0] || '/home'
      gaEvent('first_touch_hint', {
        source_hint: source,
        landing_path: path,
        page_name: pageName,
        referrer: ref ? ref.slice(0, 200) : ''
      })
      sessionStorage.setItem(firstKey, '1')
    } catch {}
  }, [])
  return null
}
